import { CheckCircleIcon, XIcon } from '@heroicons/react/solid';
import toast from 'react-hot-toast';

import { AnimatePresence, motion } from 'framer-motion';
import Link from 'next/link';

export function typeshareToast({
  type,
  title,
  text,
  secondaryText = null,
  href = '#',
}) {
  toast.custom(
    (t) => (
      <AnimatePresence>
        {t.visible && (
          <motion.div
            key={t.id}
            layout
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 50 }}
            transition={{ duration: 0.2 }}
            className={`pointer-events-auto relative flex w-full max-w-sm items-start overflow-hidden rounded-lg border border-gray-100 bg-white antialiased shadow-md shadow-gray-400/5`}
          >
            <div className="absolute left-0 h-full w-[1px] bg-gradient-to-b from-transparent via-green-500 to-transparent"></div>
            <div className="w-0 flex-1 p-3">
              <div className="flex items-start">
                <div className="mt-0 flex-shrink-0">
                  <CheckCircleIcon className={'h-5 w-5 text-green-500'} />
                </div>
                <div className="ml-3 flex flex-1 flex-col">
                  <p className="text-sm font-medium text-gray-900">{title}</p>
                  <p className="mt-0.5 text-sm font-normal text-gray-800">
                    {text}{' '}
                    {secondaryText && (
                      <span className="text-gray-500">{secondaryText}</span>
                    )}
                  </p>
                  {type === 'cta' && (
                    <Link
                      target={'_blank'}
                      href={href}
                      className="mt-2 text-sm font-normal text-blue-500"
                    >
                      View post
                    </Link>
                  )}
                </div>
              </div>
            </div>

            <button
              onClick={() => toast.dismiss(t.id)}
              className="mt-2 mr-2 text-gray-500 hover:text-gray-600 focus:outline-none"
            >
              <XIcon className="h-4 w-4" aria-hidden="true" />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    ),
    {
      position: 'bottom-right',
    },
  );
}
